import { SortModelItem } from "ag-grid-community";
import axios from "axios";
import { IRule } from "../../types";
import { IRulesApiFilter } from "../types";

export interface IGetRulesParams {
    filter?: IRulesApiFilter,
    sortBy?: {
        field: string,
        order: SortModelItem['sort']
    }
    start?: number,
    limit?: number
}

export const getRules = async (params?: IGetRulesParams): Promise<{
    rows: IRule[]
}> => {
    const response = await axios.post('/booking/rule/list', {
        filter: params?.filter,
        sortBy: params?.sortBy,
        start: params?.start,
        limit: params?.limit
    });
    return response.data;
};